export function getContextMenuPosition(
  position,
  { menuWidth = 200, menuHeight = 240, padding = 8 } = {}
) {
  if (!position) return { x: 0, y: 0 };
  if (typeof window === "undefined") return { x: position.x, y: position.y };

  const viewportWidth = window.innerWidth || 0;
  const viewportHeight = window.innerHeight || 0;

  let x = position.x;
  let y = position.y;

  if (x + menuWidth + padding > viewportWidth) {
    x = Math.max(padding, viewportWidth - menuWidth - padding);
  }
  if (y + menuHeight + padding > viewportHeight) {
    y = Math.max(padding, viewportHeight - menuHeight - padding);
  }

  return { x, y };
}
